import { rootEventBus, EnumRootEventBus } from "../../../../../src/managers/RootEventBus";
import { eventBus, EnumEventBus } from "./EventBus";
import Angle from "../../../../../src/entities/Angle/Angle";
import { Coord } from "../../../../../src/types/Interface";
import { CENTER_ANGLE_COLOR, CIRCUM_ANGLE_COLOR } from "../../../../../src/types/Config";
import getDistanceBtwPoints from "../../../../../src/utils/getDistanceBtwPoints";
import calcAngles from "../../../../../src/utils/math/calcAngles";
import generateAngle from "../../../../../src/utils/generator/generateAngle";


export default class AngleManager {
  centerAngle = new Angle("center", CENTER_ANGLE_COLOR);
  circumAngle = new Angle("circum", CIRCUM_ANGLE_COLOR);
  cloneCircumAngles:Angle[] = [new Angle("circum2", CIRCUM_ANGLE_COLOR), new Angle("circum3", CIRCUM_ANGLE_COLOR)]
  constructor() {
    rootEventBus.on(EnumRootEventBus.startedCircleAnim, () => this.setAllVisible(false));
    rootEventBus.on(EnumRootEventBus.completedCircleAnim, () => this.setAllVisible(true));
  }

  setAllVisible(status: boolean) {
    this.centerAngle.setVisible(status);
    this.circumAngle.setVisible(status);
  }

  private emitAngles = (degree: number) => eventBus.emit(EnumEventBus.setCalcLine, degree);
  private drawCenterAngle(cPoint: Coord, s1Point: Coord, s2Point: Coord, clockwise: boolean): number {
    const { startRadian, endRadian } = calcAngles(cPoint, s1Point, s2Point);
    const degree = generateAngle({ startRadian, endRadian }, clockwise);
    this.centerAngle.draw(cPoint, startRadian, endRadian, degree, clockwise);
    this.centerAngle.x = cPoint.x;
    this.centerAngle.y = cPoint.y;
    return degree;
  }

  private drawCircumAngle(circumPoint: Coord, s1Point: Coord, s2Point: Coord, degree: number, clockwise: boolean) {
    const angles = calcAngles(circumPoint, s1Point, s2Point);
    const smallDistance = Math.min( getDistanceBtwPoints(circumPoint, s1Point), getDistanceBtwPoints(circumPoint, s2Point) );
    this.circumAngle.smallDistance = smallDistance;
    this.circumAngle.draw(circumPoint, angles.startRadian, angles.endRadian, degree / 2, clockwise);
    this.circumAngle.x = circumPoint.x;
    this.circumAngle.y = circumPoint.y;
  }

  draw([cPoint, s1Point, s2Point, circumPoint]: Coord[], clockwise: boolean) {
    const centerDegree = this.drawCenterAngle(cPoint, s1Point, s2Point, clockwise);
    this.drawCircumAngle(circumPoint, s1Point, s2Point, centerDegree, clockwise);
    this.emitAngles(centerDegree);
  }
}
